"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalizeControlsFooter = void 0;

var _react = _interopRequireDefault(require("react"));

var _molecules = require("../../../molecules");

var _atoms = require("../../../atoms");

var _Tracker = require("../../../util/Tracker");

require("./PersonalizeControlsFooter.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic, Drew Burnett
 */
var PersonalizeControlsFooter = function PersonalizeControlsFooter(_ref) {
  var buttonTitle = _ref.buttonTitle,
      buttonDisabled = _ref.buttonDisabled,
      onButtonClick = _ref.onButtonClick;

  var handleOnButtonClick = function handleOnButtonClick(e) {
    if (typeof onButtonClick === 'function') {
      (0, _Tracker.trackEvent)({
        action: "Step Button ".concat(buttonTitle, " Pressed"),
        element: e.currentTarget
      });
      onButtonClick();
    }
  };

  return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "FooterSection personalize-controls-footer"
  }, /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    disabled: buttonDisabled,
    primary: true,
    content: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: buttonTitle,
      marginRight: "2"
    }), /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 16,
      type: _atoms.Icon.Type.CheveronRight
    })),
    marginRight: "2",
    onClick: handleOnButtonClick
  }));
};

exports.PersonalizeControlsFooter = PersonalizeControlsFooter;
PersonalizeControlsFooter.defaultProps = {
  buttonDisabled: false
};